import { FunctionComponent as F } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PROTOCOL, SUBMIT_TAX, VENDORS } from "../../../core/router/paths";
import TextTooltip from "../Tooltip/TextTooltip";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';


interface IProps
{
  listing: { listingId: number, listingCurrencySymbol: string },
  vendorId: number,
  size?: number
}

interface IParams
{
  protocolId?: string
}

const UpdateTax: F<IProps> = (props: IProps) =>
{
  const navigate = useNavigate();
  const params: IParams = useParams();
  const listing = props.listing;

  return(
    <TextTooltip lines={["Update tax for vendor"]}>
      <MonetizationOnIcon
        fontSize='small'
        sx={{ height: props.size || 17, color: 'lightGray', cursor: 'pointer' }}
        onClick={() => navigate(
          PROTOCOL + "/" + params.protocolId + "/" + VENDORS + "/" + props.vendorId + "/" + SUBMIT_TAX,
          { state: { listing } })}/>
    </TextTooltip>);
};

export default UpdateTax;
